import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetAuthorisedRepresentativesByEnterpriseIdMessages } from './messages';

export function getGetAuthorisedRepresentativesByEnterpriseIdCacheKey(
  enterpriseId: number | null | undefined,
) {
  return `/api/AuthorisedRepresentative/GetAuthorisedRepresentativesByEnterpriseId/${enterpriseId}`;
}

export interface useGetAuthorisedRepresentativesByEnterpriseIdOptions {
  shouldFetch?: boolean;
}

export function useGetAuthorisedRepresentativesByEnterpriseId(
  enterpriseId: number | null | undefined,
  options?: useGetAuthorisedRepresentativesByEnterpriseIdOptions,
) {
  const mergedOptions: useGetAuthorisedRepresentativesByEnterpriseIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { authorisedRepresentativeApi } = usePrivate();

  const results = useSWR(
    authorisedRepresentativeApi && mergedOptions.shouldFetch
      ? getGetAuthorisedRepresentativesByEnterpriseIdCacheKey(enterpriseId)
      : null,
    () =>
      authorisedRepresentativeApi?.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
        enterpriseId!,
      ),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetAuthorisedRepresentativesByEnterpriseIdMessages[
            'useGetAuthorisedRepresentativesByEnterpriseId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetAuthorisedRepresentativesByEnterpriseId> error fetching authorised representatives.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !authorisedRepresentativeApi;

  return { ...results, isLoadingOrValidating };
}
